var AddUpdateAssessmentViolationController = /** @class */ (function () {
    /*@ngInject*/
    function AddUpdateAssessmentViolationController($rootScope, $timeout, candidateService, modalService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.candidateService = candidateService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    AddUpdateAssessmentViolationController.prototype.$onInit = function () {
        //variables
        this.proctoringIssueReasons = ['No Images', 'Partial Images', 'Images Not Clear', 'Same Images Recorded', 'Other'];
        this.proctoringViolationReasons = ['Multiple Faces', 'Window/Time Violation', 'Other'];
        this.reason = [];
        this.isReportUpdateInProgress = false;
        this.comment = '';
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.assessmentInfoToModify = angular.copy(this.assessmentInfo.assessmentReportInfoList[this.assessmentInfo.assessmentReportInfoList.length - 1]);
        if (_.isNull(this.assessmentInfoToModify.type)) {
            this.assessmentInfoToModify.type = 'Proctoring Issue';
        }
        this.onTypeChanged();
        if (this.assessmentInfoToModify.commentDto) {
            this._scrollToLastComment();
        }
    };
    AddUpdateAssessmentViolationController.prototype.onTypeChanged = function () {
        if (this.assessmentInfoToModify.type == 'Proctoring Issue') {
            this.reasons = this.proctoringIssueReasons;
            this.assessmentInfoToModify.isViolation = true;
        }
        else if (this.assessmentInfoToModify.type == 'Proctoring Violation') {
            this.reasons = this.proctoringViolationReasons;
            this.assessmentInfoToModify.isViolation = true;
        }
        else {
            this.reasons = [];
            this.assessmentInfoToModify.reason = "";
            this.assessmentInfoToModify.isViolation = false;
        }
    };
    AddUpdateAssessmentViolationController.prototype._scrollToLastComment = function () {
        var _this = this;
        this.$timeout(function () {
            var totalComments = _this.assessmentInfo.assessmentReportInfoList.length - 1;
            var lastCommentElementId = _this.assessmentInfoToModify.commentDto.id + "-" + totalComments;
            scrollIntoView(document.getElementById(lastCommentElementId), { behavior: "smooth", block: "end", scrollMode: "if-needed" });
        }, 200);
    };
    AddUpdateAssessmentViolationController.prototype.cancel = function () {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    };
    AddUpdateAssessmentViolationController.prototype.updateAssessment = function () {
        var _this = this;
        this.isReportUpdateInProgress = true;
        this.assessmentInfoToModify.commentDto = { comment: this.comment, user: { firstName: this.$rootScope.userDetails.firstname, lastName: this.$rootScope.userDetails.lastname } };
        var generatingReportDialog = bootbox.dialog({
            message: '<span class="text-center" style="display: flex;align-items: center;justify-content: center;"><span style="margin-right:10px">Updating Report</span><i class="fa fa-spinner fa-spin"></i></span>',
            closeButton: false
        });
        this.candidateService.updateCandidateReportDetails(this.companyId, this.assessmentInfo.candidateAssessmentDetailId, this.assessmentInfoToModify, function (data) {
            // this.assessmentInfo = angular.copy(data);
            _this.isReportUpdateInProgress = false;
            generatingReportDialog.modal('hide');
            _this.alertsAndNotificationsService.showBannerMessage(data.statusMessage, 'success');
            // if (this.assessmentInfoToModify.addProctoringImagesToReport) {
            //     this.alertsAndNotificationsService.showBannerMessage('Report has been regenerated with Proctoring flag turned on', 'success');
            // } else {
            //     this.alertsAndNotificationsService.showBannerMessage('Report updated successfully', 'success');
            // }
            _this.successCallback();
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AddUpdateAssessmentViolationController.prototype.getUserConfirmation = function (comment) {
        this._launchDeleteCommentConfirmation(comment);
    };
    AddUpdateAssessmentViolationController.prototype._launchDeleteCommentConfirmation = function (comment) {
        var _this = this;
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: "Deleting the comment (and any associated icon) entered. Are you sure to continue?",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this._deleteComment(comment);
                }
            }
        });
    };
    AddUpdateAssessmentViolationController.prototype._deleteComment = function (comment) {
        var _this = this;
        this.candidateService.deleteCommentFromCandidateReportDetails(this.assessmentInfo.candidateAssessmentDetailId, comment.id, function (data) {
            _this.assessmentInfo = data;
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fas fa-check fa-fw fa-lg'></i><strong>Comment Deleted!</strong></div>",
                message: 'Comment Deleted successfully.',
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }, function (error) {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-danger' style='margin-bottom: 0px;'><i class='fa fa-times-circle fa-fw fa-lg'></i><strong>Comment Delete Failed!</strong></div>",
                message: error.message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        });
    };
    AddUpdateAssessmentViolationController.prototype.receiveFormalizedComment = function (event) {
        this.comment = event;
    };
    AddUpdateAssessmentViolationController.prototype.onVoiceTranscript = function (transcript) {
        if (this.comment) {
            this.comment += ' ' + transcript;
        }
        else {
            this.comment = transcript;
        }
    };
    return AddUpdateAssessmentViolationController;
}());
export { AddUpdateAssessmentViolationController };
AddUpdateAssessmentViolationController.$inject = ['$rootScope', '$timeout', 'candidateService', 'modalService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './add-update-assessment-violation.html';
import * as TEMPLATE from 'raw-loader!./add-update-assessment-violation.html';
export var AddUpdateAssessmentViolationComponent = {
    selector: 'addUpdateAssessmentViolation',
    component: {
        bindings: {
            assessmentInfo: '<',
            successCallback: '&',
            cancelCallback: '&'
        },
        controller: AddUpdateAssessmentViolationController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/reports/reviewReports/addUpdateAssessmentViolation/add-update-assessment-violation.html'
    }
};
//# sourceMappingURL=add-update-assessment-violation.component.js.map